import { render, staticRenderFns } from "./productShare.vue?vue&type=template&id=0673f9db&scoped=true"
import script from "./productShare.vue?vue&type=script&lang=js"
export * from "./productShare.vue?vue&type=script&lang=js"
import style0 from "./productShare.vue?vue&type=style&index=0&id=0673f9db&prod&lang=css"
import style1 from "./productShare.vue?vue&type=style&index=1&id=0673f9db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673f9db",
  null
  
)

export default component.exports